import { PaperProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RemindingTone, useAdminInvoiceQuery } from '../../../../api/gql';
import { RemindingToneInfoBox } from '../../../../components/RemindingToneInfoBox';

type Props = {
  invoiceId: string;
} & PaperProps;

export const InvoiceRemindingToneBox = ({ invoiceId, ...rest }: Props) => {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useAdminInvoiceQuery({
    id: invoiceId,
  });
  return (
    <RemindingToneInfoBox
      tone={data?.adminInvoice?.remindingTone ?? RemindingTone.Neutral}
      isLoading={isLoading}
      errorMessage={isError ? (t('query.error.default') as string) : undefined}
      titleProps={{ variant: 'h2' }}
      showIcon={false}
      {...rest}
    />
  );
};
